<div class="relative min-h-screen overflow-hidden">
  <div class="pointer-events-none absolute inset-0">
    <div
      class="absolute -top-24 -left-24 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl animate-pulse"
    ></div>
    <div
      class="absolute -bottom-24 -right-24 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl animate-pulse delay-1000"
    ></div>
  </div>

  <div class="relative z-10">
    <router-outlet />
  </div>
</div>
